import { INTERNAL_ERROR_STATUS, SUCCESS_STATUS } from 'services/api'
import validator from 'validator'

const cuitLen = 11
const dataUno = 1
const dataDos = 2
const dataTres = 3
const dataCuatro = 4
const dataSeis = 6
const dataSiete = 7
const dataOcho = 8
const dataNueve = 9
const dataDiez = 10

// TODO: Fix SonarQube regex security hotspot for this email validation
const isValidEmail = (email: string): boolean => {
  const normalizedEmail = email.toLowerCase()

  if (!validator.isEmail(normalizedEmail)) {
    return false
  }
  const localPart = normalizedEmail.split('@')[0]
  const localPartRegex = /^[a-z0-9._-]+$/i

  return localPartRegex.test(localPart)
}
const hasProgressiveChars = (value: string, maxLength = 5): boolean => {
  for (let i = 0; i < value.length - (maxLength - dataUno); i += dataUno) {
    const subChars = value.slice(i, i + maxLength)
    let isGrowing = true
    let isDecrease = true
    for (let j = dataUno; j < maxLength; j += dataUno) {
      if (subChars.charCodeAt(j) !== subChars.charCodeAt(j - dataUno) + dataUno) {
        isGrowing = false
      }
      if (subChars.charCodeAt(j) !== subChars.charCodeAt(j - dataUno) - dataUno) {
        isDecrease = false
      }
    }
    if (isGrowing || isDecrease) {
      return true
    }
  }
  return false
}
const validCuilsPrefix: string[] = ['20', '23', '24', '25', '26', '27']

const isCuil = (cuil: string): boolean => validCuilsPrefix.includes(cuil.slice(0, dataDos))

const isValidCuil = (cuil: string): boolean => {
  if (cuil.length !== cuitLen) {
    return false
  }

  const [checkDigit, ...rest] = cuil.split('').map(Number).reverse()

  const total = rest.reduce((acc, cur, index) => acc + cur * (dataDos + (index % dataSeis)), 0)

  const mod11 = cuitLen - (total % cuitLen)

  if (mod11 === cuitLen) {
    return checkDigit === 0
  }

  if (mod11 === dataDiez) {
    return false
  }

  return checkDigit === mod11
}

const isSuccessStatus = (...args: number[]) => args.every((arg: number) => SUCCESS_STATUS.includes(arg))
const isInternalErrorStatus = (...args: number[]) => args.every((arg: number) => INTERNAL_ERROR_STATUS.includes(arg))

const maxLengthcodArea = (phoneLength: number, countryPhoneCodeLength: number, countryCodAreaLength: number): number => {
  if (
    (phoneLength === dataDiez && countryPhoneCodeLength === dataTres) ||
    (phoneLength === dataNueve && countryPhoneCodeLength === dataCuatro)
  )
    return dataUno
  if (
    (phoneLength === dataDiez && countryPhoneCodeLength === dataDos) ||
    (phoneLength === dataNueve && countryPhoneCodeLength === dataTres) ||
    (phoneLength === dataOcho && countryPhoneCodeLength === dataCuatro)
  )
    return dataDos
  if (
    (phoneLength === dataNueve && countryPhoneCodeLength === dataDos) ||
    (phoneLength === dataOcho && countryPhoneCodeLength === dataTres) ||
    (phoneLength === dataSiete && countryPhoneCodeLength === dataCuatro)
  )
    return dataTres
  // Si countryPhoneCodeLength es dataTres y countryCodAreaLength es dataCuatro, devuelve dataCuatro, asegurando que no supere los 14 caracteres
  if (countryPhoneCodeLength === dataTres && countryCodAreaLength === dataCuatro) return dataCuatro
  // Si no se cumple ninguna de las condiciones anteriores, devuelve dataCuatro para garantizar un máximo de 14 caracteres
  return dataCuatro
}

const maxLengthNumber = (countryPhoneCodeLength: number, countryCodAreaLength: number): number => {
  if (countryPhoneCodeLength === dataDos && countryCodAreaLength === dataDos) return dataDiez
  if (
    (countryPhoneCodeLength === dataDos && countryCodAreaLength === dataTres) ||
    (countryPhoneCodeLength === dataTres && countryCodAreaLength === dataDos) ||
    (countryPhoneCodeLength === dataCuatro && countryCodAreaLength === dataUno)
  )
    return dataNueve
  if (countryPhoneCodeLength === dataTres && countryCodAreaLength === dataCuatro) return dataSiete
  if (
    (countryPhoneCodeLength === dataTres && countryCodAreaLength === dataTres) ||
    (countryPhoneCodeLength === dataDos && countryCodAreaLength === dataCuatro) ||
    (countryPhoneCodeLength === dataCuatro && countryCodAreaLength === dataDos)
  )
    return dataOcho
  if (countryPhoneCodeLength === dataCuatro && countryCodAreaLength === dataCuatro) return dataSeis
  if (
    (countryPhoneCodeLength === dataCuatro && countryCodAreaLength === dataTres) ||
    (countryPhoneCodeLength === dataTres && countryCodAreaLength === dataCuatro)
  )
    return dataSiete
  // Si no se cumple ninguna de las condiciones anteriores, devuelve dataDiez para garantizar un máximo de 14 caracteres
  return dataDiez
}

export { isValidEmail, isValidCuil, hasProgressiveChars, isCuil, isSuccessStatus, isInternalErrorStatus, maxLengthcodArea, maxLengthNumber }
